import { render, staticRenderFns } from "./CourseLocationItem.vue?vue&type=template&id=234e8192"
import script from "./CourseLocationItem.vue?vue&type=script&lang=js"
export * from "./CourseLocationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports